export enum Flags {
  test = 'test-flag',
  creatorSurvey = 'creator-survey',
  bubboGame = 'bubbo-game',
  caketowerGame = 'caketower-game',
  juicejamGame = 'juicejam-game',
  ffchessGame = 'ffchess-game',
  gameDefinitions = 'game-definitions',
  meowmeowShop = 'meow-meow-shop',
  discordSkuMap = 'discord-sku-map',
}

export const RECOGNITION_CONTEXTS = [
  'leaderboard',
  'profile',
  'feed',
  'cursor',
  'building_detail',
  'weekly_popup',
  'daily_popup',
  'other',
] as const;
export type RecognitionContext = (typeof RECOGNITION_CONTEXTS)[number];

export const USER_TIERS = ['none', 'bronze', 'silver', 'gold'] as const;
export type UserTier = (typeof USER_TIERS)[number];
